<div class="container-booked mb-4">
	<div class="coaching-appt-text">
		<div class="coaching-appt-header mb-4">
			<img src="assets/images/ehe_color_cross1.svg" alt="EHE Logo" />
			<span class="coaching-appt-header-text ml-3"> Health Coaching </span>
		</div>
		<div class="coaching-appt-title mb-4">Confirmed: Your Health Coaching Session is booked!</div>
		<div class="coaching-appt-body">
			<p>
				Our Health Coaches are trained and credentialed experts in a range of areas. They provide personalised plans and
				resources to improve daily habits related to exercise, sleep, mental health, nutrition, weight management,
				stress and more.
			</p>
			<p>You can review your appointment details in the My Appointments page. We look forward to see you soon!</p>
		</div>
		<div class="coaching-appt-button-container book-now">
			<button
				class="button"
				mat-button
				(click)="viewAppointment()"
				[translate]="'health-coach.sections.wellness.coaching-appointment.booked-ha-complete.view-appointment-button'">
				View Appointment Details
			</button>
		</div>
	</div>
	<div class="coaching-appt-image-container">
		<div class="coaching-appt-image-wrapper coaching-appt-image2"></div>
	</div>
</div>
